import React, { useEffect, useRef, useState } from "react";
import "./About.css";
import About1 from "./tulir1.jpg";
import About2 from "./tulir2.jpg";
import About3 from "./tulir3.jpg";
import { Link } from "react-router-dom";

const About = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  
  const images = [
    { src: About1, alt: "Tulir Matrimony Event 1", title: "Happy Couples" },
    { src: About2, alt: "Tulir Matrimony Event 2", title: "Memorable Moments" },
    { src: About3, alt: "Tulir Matrimony Event 3", title: "Celebrating Love" },
  ];

  // Intersection Observer for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // Auto-rotate carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [images.length]);

  const goToSlide = (index) => {
    setActiveSlide(index);
  };

  const nextSlide = () => {
    setActiveSlide((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setActiveSlide((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <section className="about-premium-section" ref={sectionRef}>
      {/* Background Decorative Elements */}
      <div className="about-bg-decoration">
        <div className="decoration-circle circle-1"></div>
        <div className="decoration-circle circle-2"></div>
        <div className="decoration-circle circle-3"></div>
      </div>

      <div className="about-premium-container">
        {/* Left Side - Content */}
        <div className={`about-content ${isVisible ? "fade-in-left" : ""}`}>
          <div className="about-badge">
            <span className="badge-icon">💝</span>
            <span className="badge-text">Since 2015</span>
          </div>
          
          <h2 className="about-title">
            <span className="title-gradient">Tulir</span> Matrimony
          </h2>
          
          <div className="about-subtitle">
            <span className="subtitle-line"></span>
            <p>Your Journey to a Lifetime of Togetherness Begins Here</p>
          </div>
          
          <div className="about-description">
            <p className="description-text">
              துளிர் மாட்ரிமோனி உங்கள் வாழ்க்கை துணையை தேர்ந்தெடுக்க உதவ ஒரு
              சிறந்த தளமாகும். நாங்கள் வாடிக்கையாளர்களுக்கு அவர்களின்
              விருப்பங்கள் மற்றும் நம்பிக்கைகளை மதித்து, பாதுகாப்பான மற்றும்
              நம்பகமான சேவைகளை வழங்க கடமைப்பட்டுள்ளோம்.
            </p>
            <p className="description-text highlight-text">
              துளிர் மாட்ரிமோனி மூலம், நீங்கள் உங்கள் வாழ்நாளின் சிறந்த துணையை 
              கண்டுபிடித்து வாழ்க்கையை மகிழ்ச்சியோடு கழிக்க முடியும்.
            </p>
          </div>
          
          <div className="about-stats">
            <div className="stat-item">
              <div className="stat-number">1K+</div>
              <div className="stat-label">Happy Couples</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">5K+</div>
              <div className="stat-label">Trusted Members</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">98%</div>
              <div className="stat-label">Success Rate</div>
            </div>
          </div>
          
          <Link to="/Login" className="about-cta-btn">
            <span>Join Our Family</span>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </Link>
        </div>
        
        {/* Right Side - Premium Carousel */}
        <div className={`about-carousel-wrapper ${isVisible ? "fade-in-right" : ""}`}>
          <div className="carousel-container">
            <div className="carousel-main">
              <div 
                className="carousel-track"
                style={{ transform: `translateX(-${activeSlide * 100}%)` }}
              >
                {images.map((image, index) => (
                  <div key={index} className="carousel-slide">
                    <div className="carousel-image-wrapper">
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="carousel-image"
                      />
                      <div className="carousel-overlay">
                        <div className="overlay-content">
                          <span className="overlay-icon">✨</span>
                          <h4>{image.title}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              
              {/* Navigation Buttons */}
              <button className="carousel-nav-btn prev-btn" onClick={prevSlide}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <button className="carousel-nav-btn next-btn" onClick={nextSlide}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
            
            {/* Dots Indicator */}
            <div className="carousel-dots">
              {images.map((_, index) => (
                <button
                  key={index}
                  className={`carousel-dot ${activeSlide === index ? "active" : ""}`}
                  onClick={() => goToSlide(index)}
                />
              ))}
            </div>
            
            {/* Thumbnails */}
            <div className="carousel-thumbnails">
              {images.map((image, index) => (
                <div
                  key={index}
                  className={`thumbnail ${activeSlide === index ? "active" : ""}`}
                  onClick={() => goToSlide(index)}
                >
                  <img src={image.src} alt={`Thumbnail ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      
      {/* Floating Elements */}
      <div className="floating-element element-1">❤️</div>
      <div className="floating-element element-2">💕</div>
      <div className="floating-element element-3">💑</div>
    </section>
  );
};

export default About;